<template>
  <thead class="thead">
    <tr>
      <th>{{ $t('vaApp.headers.callId') }}</th>
      <th>{{ $t('vaApp.headers.callerUser') }}</th>
      <th>{{ $t('vaApp.headers.callerDidNumber') }}</th>
      <th>{{ $t('vaApp.headers.calleeDidNumber') }}</th>
      <th>{{ $t('vaApp.headers.startedAt') }}</th>
      <th>{{ $t('vaApp.headers.endedAt') }}</th>
      <th>{{ $t('vaApp.headers.callTime') }}</th>
      <th class="space-column" />
      <th /> <!-- Manual Analysis Column -->
    </tr>
  </thead>
</template>

<style lang="scss" scoped>
  .thead {
  position: sticky;
  top: 0;
  background: $bgcolor-base;

  th {
    width: 160px;
    height: 40px;
    padding-inline: $basespace-200;
    border-bottom: 1px solid #E3E3E3;
    color: $textcolor-light;
    font-family: "Noto Sans JP";
    font-size: $fontsize-100;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
    text-align: left;

    &:first-child {
      padding-left: 40px;
      width:230px;
    }

    &.space-column {
      width: auto;
    }
  }
}
</style>

